import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

export default class ChargesOrderDifferences {
  file?: File;
  @observable distributorId: string;
  @observable paymentRequestId?: string;
}

export const ChargesOrderDifferencesValidationRules: EntityValidationRules<ChargesOrderDifferences> = {
  distributorId: {
    required: true,
  },
  file: {
    required: true,
    isFileType: {
      type: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", ""], // On Windows without Office mime type is empty string %)
      customMessage: "excel",
    },
  },
  paymentRequestId: {
    required: true,
  },
};
